import { render, staticRenderFns } from "./CustomerOdontogram.vue?vue&type=template&id=0f38413a"
import script from "./CustomerOdontogram.vue?vue&type=script&lang=js"
export * from "./CustomerOdontogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports